module.exports = __webpack_public_path__ + "img/features-img3.906eda6a.png";